// Ignore bootstrap file fore coverage
/* istanbul ignore file */

import '../css/ob1.scss';
import '../css/index.scss';
import { App } from './app/app';

// Initialise the application
const app = new App();

app.initApplication(Eui.stage);
